import pkg from '../../package.json';

const formatAppName = (str: string): string => str.replaceAll(' ', '');
export const ApplicationName = 'SMEJ Security Jam';
const FormatedAppName = formatAppName(ApplicationName);
export const StackNamePrefix = `${FormatedAppName}Stack`;
export const SMEJSecurityJamNonCompliantStackName = [StackNamePrefix, 'NonCompliant'].join('-');
export const SMEJSecurityJamPlayerCoreStackName = [StackNamePrefix, 'PlayerCore'].join('-');

export const Version = pkg.version;
export const CreatedBy = 'sme.ccoe@sonymusic.co.jp';
export const ContactTo = 'sme.ccoe@sonymusic.co.jp';
export const Owner = 'sme.ccoe@sonymusic.co.jp';
const CostManagementTagPrefix = 'smej:cost-management';
export const CostManagementTag = {
  environment: `${CostManagementTagPrefix}:environment`,
  owner: `${CostManagementTagPrefix}:owner`,
  service: `${CostManagementTagPrefix}:service`
};
const StackTagPrefix = `smej:ccoe`;
export const StackTag = {
  contactTo: `${StackTagPrefix}:contact-to`,
  createdBy: `${StackTagPrefix}:created-by`,
  modifiedAt: `${StackTagPrefix}:modified-at`,
  version: `${StackTagPrefix}:version`,
};
export interface EnvForIndex {
  identityPoolId: string;
  userPoolClientId: string;
  userPoolId: string;
  wssApiEndpoint: string;
}
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

interface ControlStatusJP {
  [key: number]: string;
}
export const ControlStatusJP: ControlStatusJP = {
  0: '非準拠',
  1: '申請済み',
  2: 'チェック中',
  3: '一部準拠',
  4: '完了',
};

export const IdPrefix = FormatedAppName.toLowerCase();
export const StackDescription = 'This stack is for SMEJ Security Jam.';
export type StackIds = 'NonCompliant' | 'Game' | 'Global' | 'Core' | 'PlayerCore';

export const PathForIndex = '/dist/index';

export interface SfnEvent {
  accountId: string;
}

export const Tables = {
  Account: "Account",
  Control: "Control",
  ControlSetting: "ControlSetting",
  Connections: "Connections",
};

export const GameSchedulerNames = {
  calculateScores: 'smej-security-jam-calculate-scores-scheduler',
  prepareEvent: 'smej-security-jam-prepare-event-scheduler',
  reevaluateConfigRulesEvent: 'smej-security-jam-reevaluate-config-rules-event-scheduler'
};
